import { useTranslation } from '@hooks';
import {
    AgreementModalWrapper,
    MarginWrapper,
    StaticContentArea,
    StaticContentRow,
} from 'components/styles/StaticPagesStyles';
import { H3, Subtitle3, Text3 } from '@components/styles/Typography';

const ContactUsAgreement = () => {
    const { locale } = useTranslation();

    return (
        <AgreementModalWrapper>
            {locale === 'tr' ? (
                <StaticContentArea>
                    <H3>
                        İLETİŞİM KUTUSU ÜZERİNDEN İLETİŞİME GEÇEN
                        ZİYARETÇİ/MÜŞTERİLERE YÖNELİK KİŞİSEL VERİLERİNİN
                        İŞLENMESİNE İLİŞKİN AYDINLATMA METNİ
                    </H3>
                    <MarginWrapper>
                        <Text3>Değerli Müşterimiz/Ziyaretçilerimiz;</Text3>
                        <Text3>
                            Kişisel verileriniz 6698 sayılı Kişisel Verilerin
                            Korunması Kanunu uyarınca veri sorumlusu olarak
                            KEİKEİ TEKSTİL VE GİYİM SANAYİ TİCARET ANONİM
                            ŞİRKETİ (“KEİKEİ’’ veya “Şirket”) tarafından aşağıda
                            açıklanan şekilde işlenebilecektir.
                        </Text3>
                        <MarginWrapper>
                            <Subtitle3>
                                Kişisel Verileri Toplama Yöntemleri ve Hukuki
                                Sebepleri
                            </Subtitle3>
                            <Text3>
                                Şirketimizce kişisel verileriniz; internet
                                sitesine girişyapmanız halinde site içerisinde
                                yer alan iletişim kutusu, mail adresi veya
                                iletişim numarası aracılığıyla tarafımızla
                                iletişime geçilmesi halinde öğrenilen verilerden
                                elde etmektedir.
                            </Text3>
                            <Text3>
                                Kişisel verileriniz; bir sözleşmenin kurulması
                                veya ifasıyla doğrudan doğruya ilgili
                                olması(Sözleşme şartları hususunda tarafımızla
                                iletişime geçilmesi, sözleşme gereği teslimat
                                yapılacak adresin değiştirilmesi,sözleşme öncesi
                                ürün hakkında bilgi alınması,sözleşme öncesi
                                müzakere edilmesi), ilgili kişinin temel hak ve
                                özgürlüklerine zarar vermemek kaydıyla veri
                                sorumlusunun meşru menfaatleri için veri
                                işlemenin zorunlu olması (müşteri memnuniyeti
                                kapsamındaşikâyet, soru ve önerilerin alınması
                                için iletişim kanallarının kullanılmak zorunda
                                olunması) hukuki sebeplerine dayalı olarak
                                işlemektedir
                            </Text3>
                        </MarginWrapper>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>
                            Farklı Aşamalarda İşlenebilecek Veri Kategorileri ve
                            Veri Türleri
                        </Subtitle3>
                        <StaticContentRow>
                            <Subtitle3>Kimlik:</Subtitle3>
                            <Text3>
                                Ad-Soyad, T.C. Kimlik Numarası, Doğum Tarihi
                            </Text3>
                        </StaticContentRow>
                        <StaticContentRow>
                            <Subtitle3>İletişim:</Subtitle3>
                            <Text3>
                                Telefon numarası, E posta adresi, Lokasyon,
                                Ülke,
                            </Text3>
                        </StaticContentRow>
                        <Text3>
                            *İlgili kişisel verileriniz internet sitemizdeki
                            iletişim kısmında bulunan iletişim kutusunun
                            doldurulmasıaracılığı ile işlenmektedir.
                            <br />
                            ** İlgilikişisel veriniz internet sitemizdeki
                            telefon numarasından Şirket ile iletişime geçilmesi
                            halinde işlenebilmektedir.
                            <br />
                            ***İletişim kutusundaki “Mesaj” başlığı altında
                            tarafımıza iletebileceğiniz kişisel verileriniz yine
                            işbuAydınlatma Metni kapsamında işlenebilecektir
                        </Text3>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>Kişisel Verileri İşleme Amaçları</Subtitle3>
                        <Text3>
                            Kişisel verileriniz; e-ticaret sitemizden satın
                            alabileceğiniz ürünler hakkındaki soru ve
                            şikâyetlerinizin iletilmesi, satışsözleşmesinin
                            müzakere edilmesi, sözleşme şartlarının/teslimat
                            adresinin vs. değiştirilmesi, satış öncesi ve
                            sonrası destek hizmet süreçlerinin yürütülmesi,
                            internet sitesi ziyaretçilerinin veya müşteri sorun,
                            öneri ve şikâyetlerinin çözümlenmesi, bilgi ve işlem
                            güvenliğinin tesisi, amaçlarıyla Kişisel Verilerin
                            Korunması Kanunu’nun belirttiği şartlar kapsamında
                            ve bu okuduğunuz aydınlatma metni sınırları
                            dâhilinde işlenebilecektir.
                        </Text3>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>Kişisel Verilerin Aktarılması</Subtitle3>
                        <Text3>
                            Kişisel verileriniz, “bilme gereği” ve “kullanma
                            gereği” ilkelerine uygun olarak ve gerekli veri
                            minimizasyonunu sağlanarak;yukarıda belirtilen
                            amaçların gerçekleştirilmesi doğrultusunda ve bu
                            amaçların yerine getirilmesi ile sınırlı olarak;
                            hissedarlarımızla, iş ortaklarımızla,iştiraklerimiz
                            ve bağlı şirketlerimiz ve hissedarlarıyla,
                            Şirketimizin yurtiçi ve yurtdışındakihizmet
                            sağlayıcılarıyla, pazarlama/reklam/analiz hizmeti
                            sağlayıcıları, veri tabanı ve sunucu hizmeti
                            sağlayıcıları, site kullanımlarını izleme hizmeti
                            sağlayanlar, e-posta sunucu hizmeti
                            sağlayıcıları,bilişimaltyapımızısağlayan,işleten
                            veya hizmet sunan işortaklarımızla ve hizmet
                            sağlayıcılarımızla, özel işortaklığımızınolduğu
                            kanunen yetkili kamu kurumları ve özel kişi veya
                            kuruluşlar ile üçüncü kişilereayrıca;
                            <br />
                            ● Denetleme ve durum tespit faaliyetleri için
                            uzmanlar, hukuk büroları ve denetleme firmaları ile
                            düzenleyici ve sözleşmesel yükümlülüklerin yerine
                            getirilmesi için kamu kurumları, sigorta şirketleri,
                            sosyal yardım destek fonları,iş danışmanlarıyla,
                            <br />● Yetkili idari ve denetleme kurullarıyla
                            ve/veya diğer yetkili denetleyici kurum ve
                            kuruluşlarla,hukuki uyuşmazlıkların giderilmesi veya
                            ilgili mevzuatıgereği talep halinde idari makamlar,
                            adli makamlar veya ilgili kolluk kuvvetleriyle
                            işbuaydınlatma metninde belirtilen amaçlarla
                            sınırlıolarak aktarılabilecek, yurt içinde veya yurt
                            dışında işlenebilecektir
                        </Text3>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>İlgili Kişinin Hakları</Subtitle3>
                        <Text3>
                            Kişisel verisi işlenen kişi olarak, Kanun’un ilgili
                            kişinin haklarını düzenleyen 11. maddesi kapsamında;
                            <br />
                            • Kişisel veri işlenip işlenmediğini öğrenme,
                            <br />• Kişisel verileri işlenmişse buna ilişkin
                            bilgi talep etme, <br />• Kişisel verilerin işlenme
                            amacını ve bunların amacına uygun kullanılıp
                            kullanılmadığını öğrenme,
                            <br />
                            •Yurt içinde veya yurt dışındakişisel verilerin
                            aktarıldığı üçüncü kişileri bilme,
                            <br />• Kişisel verilerin eksik veya yanlış işlenmiş
                            olması hâlinde bunların düzeltilmesini isteme,{' '}
                            <br />
                            •KVKK Mevzuatında öngörülen şartlar çerçevesinde
                            kişisel verilerin silinmesini veya yok edilmesini
                            isteme,
                            <br /> •Verilen eksik veya yanlış işlenmesi halinde
                            düzeltilmesi ile kişisel verilerinizin silinmesi
                            veya yok edilmesini talep ettiğinizde bu durumun
                            kişisel verilerinizin aktarıldığı üçüncü kişilere
                            bildirilmesini isteme,
                            <br /> • İşlenen verilerin münhasıran otomatik
                            sistemler vasıtasıyla analiz edilmesi suretiyle
                            aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
                            <br /> • Kişisel verilerinizin kanuna aykırı olarak
                            işlenmesi sebebiyle zarara uğramanız hâlinde bu
                            zararın giderilmesini talep etme haklarına
                            sahipsiniz.
                        </Text3>
                        <Text3>
                            Bu haklarınızı Veri Sorumlusuna Başvuru Usul ve
                            Esasları Hakkında Tebliğe göre kullanmak için ise
                            kvkk@keikei.com.tr iletişime geçebilir veya
                            www.keikei.com adresinde yer alan “İlgili Kişi
                            Başvuru Formu”nu doldurup;
                            <br />
                            •“Dolapdere Cd. Küçükbayır Sk. No:119/A K:6
                            Şişli/İstanbul” adresine bizzat getirebilir,
                            <br />
                            •Belirtilen adrese, ıslakimzalı olarak noter
                            kanalıyla gönderebilir,
                            <br />
                            •keikei@hs01.kep.tr adresine güvenli elektronik ya
                            da mobil imzalı olarak, kayıtlı elektronik posta
                            adresi veya sistemimizde kayıtlı elektronik e-posta
                            adresiniz aracılığıyla iletebilirsiniz
                        </Text3>
                        <Text3>
                            Başvuruda ad, soyad, Türkiye Cumhuriyeti
                            vatandaşları için T.C. kimlik
                            numarası,yabancılariçin uyruğu, pasaport numarası
                            veya varsa kimlik numarası, tebligata esas yerleşim
                            yeri veya iş yeri adresi, varsa bildirime esas
                            elektronik posta adresi, telefon ve faks numarası ve
                            talep konusu yer almalıdır.
                        </Text3>
                    </MarginWrapper>
                    <H3>
                        KEİKEİ TEKSTİL VE GİYİM SANAYİ TİCARET ANONİM ŞİRKETİ
                    </H3>
                </StaticContentArea>
            ) : (
                <StaticContentArea>
                    <H3>
                        CLARIFICATION TEXT ON THE PROCESSING OF PERSONAL DATA OF
                        OUR WEBSITE VISITORS/MEMBERS CONTACTING THROUGH THE
                        DIALOG BOX
                    </H3>
                    <MarginWrapper>
                        <Text3>Dear Customer,</Text3>
                        <Text3>
                            Your personal data may be processed as described
                            below by Keikei Textile And Clothing Industry Trade
                            Joint Stock Company (“KEİKEİ” or “Company”)as the
                            data controller in accordance with the Law on
                            Protection of Personal Data No. 6698.
                        </Text3>
                        <MarginWrapper>
                            <Subtitle3>
                                Personal Data Collection Methods and Legal
                                Reasons:
                            </Subtitle3>
                            <Text3>
                                Our company obtains personal data from you to
                                logging in to the website and contact with us
                                via the dialog box, e-mail address or contact
                                number on the site.
                                <br />
                                Your personel data is processed for the legal
                                purposes of;
                            </Text3>
                            <Text3>
                                - Being directly related to the conclusion or
                                fulfillment of a contract (Contacting us about
                                the terms of the contract, changing the delivery
                                address in accordance with the contract, getting
                                information about the product before the
                                contract, negotiating before the contract)
                            </Text3>
                            <Text3>
                                - Data processing is mandatory for the
                                legitimate interests of the data controller,
                                provided that it does not harm the fundamental
                                rights and freedoms of the data
                                subject(Communication channels must be used to
                                receive complaints, questions and suggestions
                                within the scope of customer satisfaction.)
                            </Text3>
                        </MarginWrapper>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>
                            Data Categories and Data Types That Can Be Processed
                            at Different Stages:
                        </Subtitle3>
                        <StaticContentRow>
                            <Subtitle3>Identification:</Subtitle3>
                            <Text3>Name-Surname(*)</Text3>
                        </StaticContentRow>
                        <StaticContentRow>
                            <Subtitle3>Communication:</Subtitle3>
                            <Text3>Phone Number(*),E-mail address(**)</Text3>
                        </StaticContentRow>
                        <Text3>
                            * Your relevant personal data is obtained as a
                            result of filling the dialog box by you at our
                            website.
                            <br />
                            ** Your relevant personal data is obtained as a
                            result of contacting us with the contact number on
                            the website.
                            <br />
                            *** Your relevant personal data, which you can
                            transmit to us under the &#34;Message&#34; heading
                            in the Text dialog box, can also be processed within
                            the scope of this Clarification Text.
                        </Text3>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>Personal Data Processing Purposes</Subtitle3>
                        <Text3>
                            Your personal data can be processed fort he purposes
                            of; conveying your questions and complaints about
                            the products you can buy from our e-commerce site,
                            negotiating the sales contract, contract
                            conditions/delivery address etc., changing, pre- and
                            post-sales support service processes, resolving the
                            problems, suggestions and complaints of website
                            visitors or customers, establishing information and
                            transaction security, within the scope of the
                            conditions specified by the Law on the Protection of
                            Personal Data and within the limits of this
                            illumination text.
                        </Text3>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>Transfer of Personal Data</Subtitle3>
                        <Text3>
                            Your personal data may be processed in accordance
                            with the principles of “need to know” and “need to
                            use” and by providing the necessary data
                            minimization; with our shareholders, business
                            partners, affiliates and subsidiaries and their
                            shareholders, our company&#39;s domestic and
                            international service providers,
                            marketing/advertisement/analyze service providers,
                            database and server service providers, , providers
                            of site usage monitoring services,e-mail server
                            service providers, e-invoice and e-archive invoice
                            service providers, electronic message service
                            providers, cargo and courier companies, banks and
                            electronic payment institutions, legal and financial
                            consultancy services, independent audit service
                            providers, archiving services, our business partners
                            and service providers that provide, operate or
                            provide services to our IT infrastructure, legally
                            authorized public institutions and private persons
                            or organizations with which we have private business
                            partnerships, and third parties,
                            <br />
                            Besides;
                            <br />
                            Experts, law firms and audit firms for auditing and
                            due diligence activities and public institutions for
                            the fulfillment of regulatory and contractual
                            obligations, insrance companies, social assistance
                            support funds, business advisors,
                            <br />
                            With the authorized administrative and supervisory
                            boards and/or other authorized supervisory
                            institutions and organizations,
                            <br /> In the country or abroad, which can be
                            transferred to the administrative authorities,
                            judicial authorities or relevant law enforcement
                            authorities for the resolution of legal disputes or
                            in accordance with the relevant legislation, limited
                            to the purposes specified in this clarification
                            text.
                        </Text3>
                    </MarginWrapper>
                    <MarginWrapper>
                        <Subtitle3>Rights of data subject</Subtitle3>
                        <Text3>
                            As the person whose personal data is processed, you
                            have the rights under Article 11 of the Law as
                            follows,
                            <br />
                            • Learning whether personal data is processed or
                            not,
                            <br />• If personal data has been processed,
                            requesting information about it,
                            <br />• To learn the purpose of processing personal
                            data and whether they are used in accordance with
                            the purpose,
                            <br />
                            • Knowing the third parties to whom personal data is
                            transferred in the country or abroad,
                            <br />• Requesting correction of personal data in
                            case of incomplete or incorrect processing,
                            <br />
                            • Requesting the deletion or destruction of personal
                            data within the framework of the conditions
                            stipulated in the KVKK Legislation,
                            <br /> • When you request the deletion or
                            destruction of your personal data by correcting it
                            in case of incomplete or incorrect processing,
                            requesting that this situation be notified to the
                            third parties to whom your personal data has been
                            transferred,
                            <br /> • Objecting to the emergence of a result
                            against you by analyzing the processed data
                            exclusively through automated systems,
                            <br /> • If you incur a loss due to unlawful
                            processing of your personal data, requesting the
                            removal of this damage
                        </Text3>
                        <Text3>
                            As the person whose personal data is processed, to
                            exercise Your rights under Article 11 of the Law,
                            which regulates the rights of the person concerned
                            in line with Communiqué on Application Procedures
                            and Principles to Data Controller you can contact
                            kvkk@keikei.com.tr or fill the “Application form” on
                            the www.keikei.com;
                            <br />
                            • You may bring the form to Dolapdere Road,
                            Küçükbayır St. 119/A Şişli/İstanbul by yourself,
                            <br />
                            • You may send to the specified address, with wet
                            signature, through a notary public,
                            <br />• You may send it to keikei@hs01.kep.tr with
                            secure electronic or mobile signature, via your
                            registered e-mail address or your e-mail address
                            registered in our system.
                        </Text3>
                        <Text3>
                            In the application there must be name, surname, T.C.
                            identification number for Turkish citizens,
                            nationality, passport number and identification
                            number if any, for foreigners, place of residence or
                            business address, e-mail address for notification,
                            phone and fax number and subject of application.
                        </Text3>
                    </MarginWrapper>
                    <H3>
                        Keikei Textile and Clothing Industry Trade Joint Stock
                        Company
                    </H3>
                </StaticContentArea>
            )}
        </AgreementModalWrapper>
    );
};

export default ContactUsAgreement;
